import { apiTags } from '../../app/store/apiTags';
import { baseQuery } from "../../app/baseQuery";
import { baseApi } from 'app/baseApi';

export const clientApi = baseApi.injectEndpoints({
    reducerPath: 'clientApi',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getClients: builder.query({
            query: () => `client`,
            providesTags: [apiTags.CLIENT],
        }),
        getClientAccounts: builder.query({
            query: () => `account`,
            providesTags: [apiTags.CLIENT],
        })
    }),
});

export const { useGetClientsQuery, useGetClientAccountsQuery } = clientApi;
